import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './ConnectionStatus.css';

const ConnectionStatus = () => {
  const { apiConnected, error } = useAuth();

  if (apiConnected) {
    return (
      <div className="connection-status connection-success">
        <span className="connection-indicator"></span>
        <span className="connection-text">API Connected</span>
      </div>
    );
  }

  return (
    <div className="connection-status connection-error">
      <span className="connection-indicator"></span>
      <div className="connection-info">
        <span className="connection-text">API Disconnected</span>
        {error && <div className="connection-error-text">{error}</div>}
        <div className="connection-help">
          Make sure your backend server is running on http://localhost:5000
        </div>
      </div>
    </div>
  );
};

export default ConnectionStatus;
